import { render, staticRenderFns } from "./MarkdownDialog.vue?vue&type=template&id=e4abab52"
import script from "./MarkdownDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./MarkdownDialog.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports